// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18rGz","colMin":"styles_colMin__1ae0Z"};